import { useState } from "react";
import Image from "shared/images";
import { sectionData as sections } from "data/sections";
import { SectionData, Image as ImageType } from "shared/types";
import { Link } from "react-router-dom";
import Social from "./social/social";
import { Modal } from "shared/modal";
import { LegalModal } from "./modal-legal";

type ModalType = "PRIVACY" | "COOKIE" | null;

type FooterState = {
  type: ModalType;
  isModalOpen: boolean;
};

export const Footer = () => {
  const [footerState, setFooterState] = useState<FooterState>({
    isModalOpen: false,
    type: null,
  });

  const toggleModal = () => {
    setFooterState({
      type: null,
      isModalOpen: !footerState.isModalOpen,
    });
  };

  const openModal = (type: ModalType) => {
    setFooterState({
      type: type,
      isModalOpen: true,
    });
  };

  const year = new Date().getFullYear();

  return (
    <div className="Footer">
      <Social />

      <div className="footer-container">
        <div className="footer-nav">
          {sections.map((item: SectionData) => (
            <div key={item.section}>
              <Link to={`/${item.url}`}>
                <Image name={item.logo as ImageType} title={item.title} />
              </Link>
            </div>
          ))}
        </div>

        <div className="footer-content">
          <div className="copy">{year} @ GRUPPO MAGOG</div>

          <div className="legal">
            <span onClick={() => openModal("PRIVACY")}>Privacy</span>
            <span onClick={() => openModal("COOKIE")}>Cookie</span>
          </div>
        </div>
      </div>

      {footerState.isModalOpen && (
        <Modal close={toggleModal}>
          <LegalModal type={footerState.type} />
        </Modal>
      )}
    </div>
  );
};
